import React, { useEffect, useState } from 'react';
import '../css/main.css';
import PageBannerImage from '../Images/ISC-PropEx-BG-Image.jpg';
import SalesPurchaseImage from "../Images/ISC-PropEx-Sale&Purchase.png";
import {validation} from '../components/validation';
import PlotExchange from '../components/actions';
import {appendScript} from '../scriptAdded';
import PropertyExchangeImage from '../Images/ISC-PropEx-FormBG-Image.jpg';

import axios from 'axios';
export const PropertyScreenBanner = () => {
    return (
        <div className="jumbotron" style={{backgroundImage:`url(${PageBannerImage})`,backgroundSize:"cover"}}>
                
            <div className="container">
                <div className="row">
                    <div className="col-md-7 col-lg-7">
                        <h4 className="banner-title">Looking for LEGAL AND VALUATIONS SERVICES for your new or old property ?</h4>
                            <p>ISC Realty has a team of lawyers and valuation agents and we take pride in our 20 year old history of real estate management.</p>
                            <p>ISC is now giving property valuation, property screening and legal services for property as a paid service.</p>
                            <a class="btn btn-primary btn-lg" href="#propertyExchange" role="button">Call us to know more.</a>
                        
                    </div>
                    <div className="col-md-5 col-lg-5">
                        <img src={SalesPurchaseImage} alt="PropertyImage" style={{width:"100%"}} />
                    </div>
                </div>
                    
                        
            </div>
        
        </div>
           

       
    )
};
export const PropertyVerifed = () =>{
    return(
        <section className="propertyVerified">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                    <h4 className="banner-title" style={{textAlign:"center"}}>HOW TO GET YOUR <br/>
                    <span>PROPERTY VERIFIED?</span></h4>
                    <section className="" style={{marginTop:"40px"}}>
                        <div className="accordion" id="accordionExample">
                            <div className="card">
                                <div className="card-header" id="headingOne" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                What is property verification? 
                                
                                </div>

                                <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div className="card-body">
                                    <p>Property is one of the major profitable business nowadays and thus, investing in it is becoming very popular in the race of buying and selling the property it is important to keep the documentation of the property legal and with all the proofs, one such important aspect is property verification of the property. It is mandatory and important before buying or selling any property.</p> 
                                    <p>People spend lots of money on buying the property but try to save the money on verification, but this can lead to complexities in future. </p>   
                                </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header collapsed" id="headingTwo" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                Documents required to verify your property
                                </div>
                                <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div className="card-body">
                                    <p>1) Conveyance Deed</p>
                                       <p>2) Sale Deed</p>
                                       <p>3) Agreement to sell</p>
                                       <p>4) Power of attorney</p>
                                       <p>5) Will (if any)</p>
                                       <p>6) Relishquintment Deed</p>
                                       <p>7) Mutation Details</p>
                                    
                                </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header collapsed" id="headingThree" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                
                                Procedure to Verify the Property
                                </div>
                                <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                <div className="card-body">
                                    <h4 className="property-verify-title">1) Hire the lawyers</h4>
                                    <p>Hire the best lawyers to get all the documents ready, for submitting it to the sub-registrar office. ISC will help you choose from excellent advocates to verify the property you are buying.</p>
                                    <h4 className="property-verify-title">2) Verification</h4>
                                    <p>After you choose and hire the lawyer, they will verify all the documents according to the rights of the seller and the buyer, they will also check the registration of the documents and the payment of the stamp duty.</p>
                                </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header collapsed" id="headingFour"  data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                Frequently asked questions about the verification of the property
                                
                                </div>
                                <div id="collapseFour" className="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                                <div className="card-body">
                                    <h4 className="property-verify-title">1) What is the advantage of verifying your property?</h4>
                                    <p>Verifying your property will assure you about the rights on the property so, that you will know there are no other claims on your property. If you get involved in any future issues you will have a proof on the claim of the property.</p>
                                    <h4 className="property-verify-title">2) Who can verify the property?</h4>
                                    <p>The property is needed to be verified by an experienced property lawyer, we have an expert team of experienced advocates in Delhi for all the legal works with all the precision that is needed.</p>
                                    <h4 className="property-verify-title">3) How much time does it take?</h4>
                                    <p>The verification of the property will take a week if you have given all the required documents.</p>
                                    <h4 className="property-verify-title">4) Who should get their property verified?</h4>
                                    <p>Anybody who is planning to buy the property should get their property verified be it a businessman or a middle-class person who is buying a house.</p>

                                </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header collapsed" id="headingFive" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                How does the lawyer help here at ISC?
                                
                                </div>
                                <div id="collapseFive" className="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                                <div className="card-body">
                                    <p>You can hire advocates from ISC and find the best consult to guide you through the process.</p>
                                    <p>1) Verify your documents to find out the previous owner of the property so that there is no loophole.</p>
                                    <p>2)  Verification of the sale deed to check the rights of the seller.</p>
                                    <p>3) Verification of the conveyance deed.</p>
                                    <p>4) A general title search of the property from 13 years.</p>
                                    <p>ISC provides a solution for all types of legal issues be it property, matrimonial issues or civil cases we strive to present the best legal services in the business.</p>
                                    <p>When it comes to the professionalism we have been a professional one from the beginning. To handle real estate matters you need to have experienced lawyers by your side thus by connecting with ISC you will be guided with the best advocates. </p>
                                </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    </div>
                </div>
            </div>
        </section>
    )
}
export const PropertyExchange = () =>{
    const [exchangeForm, setexchangeForm]=useState({name:'',formComesFrom:'Property Screeing',mobileNumber:'',email:'',plot:'Plot or Land',plotNo:'',units:'2',pricePerUnit:'2000000',totalPrice:'4000000',selectedFile:null,legalOwner:false,documentValuation:false,propExProcess:false,successMessage:'',fileName:''});
    const [errors,seterrors]=useState({});
    
    const uploadPropertyValue = e =>{
        
        setexchangeForm({...exchangeForm,selectedFile:e.target.files[0]})

         console.log(exchangeForm.selectedFile)
         
    }
    
    const ExchangeSubmission = async e =>{
        e.preventDefault();
        setexchangeForm({
            ...exchangeForm,
            totalPrice:exchangeForm.pricePerUnit * exchangeForm.units
        }) 
        
        const validationErrors = validation(exchangeForm);
             seterrors({
                ...errors,
                validationErrors
    
            })
		const noErrors = Object.keys(validationErrors).length === 0;
        
        
        console.log(errors);
        if(noErrors){
            PlotExchange(exchangeForm).then((res) => {
                if(res.data.success===1){
                    setexchangeForm({
                        ...exchangeForm,
                        successMessage:res.data.message
                      })
                      alert(res.data.message);
                      window.location.reload(true);
                      
                      
                 
                 
                }
                else{
                    setexchangeForm({
                    ...exchangeForm,
                    successMessage:res.data.errorMessage
                  })
                }
               
           
           })
           .catch(error => {
                
             }
             );
		}else{
             alert('please fill up the complete form');
             
             
		} 
        
    
    }
    
    return (
         <>
           <section className="propertyExchange" id="propertyExchange" style={{backgroundImage:`url(${PropertyExchangeImage})`,backgroundSize:"cover"}}>
               <div className="container">
                   <div className="row">
                       <div className="col-md-12 col-lg-12">
                           <h4 className="property-title"><span>I want help in </span><br/>
                           screening my property for</h4>
                       </div>
                   </div>
                   <div className="row" style={{marginTop:"40px"}}>
                       <div className="col-md-3 col-lg-3">
                           <div className="property-screen-block">
                               <h4 className="property-screen-block-title">Legal Verification</h4>
                           </div>
                       </div>
                       <div className="col-md-3 col-lg-3 border-sides">
                           <div className="property-screen-block">
                               <h4 className="property-screen-block-title">Technical Verification</h4>
                           </div>
                       </div>
                       <div className="col-md-3 col-lg-3 border-right-sides">
                           <div className="property-screen-block">
                               <h4 className="property-screen-block-title">Encumbrance</h4>
                           </div>
                       </div>
                       <div className="col-md-3 col-lg-3">
                           <div className="property-screen-block">
                               <h4 className="property-screen-block-title">Loan Purpose</h4>
                           </div>
                       </div>
                   </div>
                   <form onSubmit={ExchangeSubmission}>
                   <div className="row" style={{marginTop:"40px"}}>
                       <div className="col-md-6 col-lg-6">
                           <section className="form">
                               
                               <div className="form-group">
                                   <input type="text" className="form-control" placeholder="Name" onChange={e =>setexchangeForm({...exchangeForm,name : e.target.value})} value={exchangeForm.name}></input>
                                   
                               </div>
                               <div className="form-group">
                                   <input type="number" className="form-control" placeholder="Mobile Number" onChange={e =>setexchangeForm({...exchangeForm,mobileNumber:e.target.type==='number' ? parseInt(e.target.value):e.target.value })} value={exchangeForm.mobileNumber}></input>
                                   
                               </div>
                               <div className="form-group">
                                   <input type="email" className="form-control" placeholder="Email" onChange={e =>setexchangeForm({...exchangeForm,email:e.target.value})} value={exchangeForm.email}></input>
                                   
                               </div>
                               <div className="form-group">
                                    <select id="inputState" class="form-control" onChange={e=>setexchangeForm({...exchangeForm,plot:e.target.value})} value={exchangeForm.plot}>
                                        <option value="Plot or Land">Plot or Land</option>
                                        <option>Constructed Space</option>
                                    </select>
                                    
                               </div>
                               
                               <div className="row">
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label>&nbsp;&nbsp;</label><br/>
                                            <input type="text" className="form-control" placeholder="Plot no / flat no" onChange={e=>setexchangeForm({...exchangeForm,plotNo:e.target.value})} value={exchangeForm.plotNo}></input>
                                            
                                        </div>
                                    </div>
                                    {
                                    exchangeForm.plot==='Plot or Land' ?
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label>Sq. Yd.</label><br/>
                                             <input type="number" className="form-control" placeholder="Units (sq ft, Sq Yd, Cents, Acres)" onChange={e =>setexchangeForm({...exchangeForm,units:e.target.type==='number' ? parseInt(e.target.value):e.target.value })} value={exchangeForm.units} />
                                        
                                        </div>
                                    </div>
                                    :
                                    <div className="col-6">
                                    <div className="form-group">
                                        <label>Sq. Ft.</label><br/>
                                         <input type="number" className="form-control" placeholder="Units (sq ft)" onChange={e =>setexchangeForm({...exchangeForm,units:e.target.type==='number' ? parseInt(e.target.value):e.target.value })} value={exchangeForm.units} />
                                    
                                    </div>
                                    </div>
                                    }
                                
                                </div>
                                <div className="form-group">
                                {
                                    exchangeForm.plot==='Plot or Land' ?
                                    <label>Price Per Sq. Yd.</label>
                                    : <label>Price Per Sq. Ft.</label>
                                }
                                   <input type="number" className="form-control" placeholder="Price Per Unit" onChange={e =>setexchangeForm({...exchangeForm,pricePerUnit:e.target.type==='number' ? parseInt(e.target.value):e.target.value })} value={exchangeForm.pricePerUnit}></input>
                                      </div>
                                      
                               <div class="button-wrap">
                                    <label class="file-button" for="upload">Upload Property Photo</label>
                                    <input id="upload" type="file" onChange={uploadPropertyValue}/>
                                    
                                </div>
                               

                           </section>
                           
                       </div>
                       <div className="col-md-6 col-lg-6 align-center">
                           <h4 className="price">
                               <span>Total Price</span><br/>
                               &#8377; {exchangeForm.pricePerUnit * exchangeForm.units}
                           </h4>
                           <div className="checbox-form">
                                <div class="form-check mb-2 mr-sm-2">
                                    <input className="form-check-input" type="checkbox" id="inlineFormCheck"name="legalOwner" onChange={e=>setexchangeForm({...exchangeForm,legalOwner:e.target.checked})} value={exchangeForm.legalOwner} />
                                    <label className="form-check-label">
                                    I am the legal owner of the property<br/>
                                    <span>( Brokers can contact +91 994 380 9000)</span>
                                    </label>

                                </div>
                                
                                <div class="form-check mb-2 mr-sm-2">
                                    <input className="form-check-input" type="checkbox" id="inlineFormCheck" name="documentValuation" onChange={e=>setexchangeForm({...exchangeForm,documentValuation:e.target.checked})}/>
                                    <label className="form-check-label" >
                                    I want to submit my documents for valuation </label>
                                </div>
                                <div class="form-check mb-2 mr-sm-2">
                                    <input className="form-check-input" type="checkbox" id="inlineFormCheck" name="propExProcess" onChange={e=>setexchangeForm({...exchangeForm,propExProcess:e.target.checked})}/>
                                    <label className="form-check-label" >
                                    I want to receive a call regarding PropEx process</label>
                                </div>
                                
                           </div>
                           <p style={{color:"#fff",fontSize:"18px",textAlign:"center" }}>{exchangeForm.successMessage}</p>
                           <div className="submit-button">
                               <input type="submit" className="btn btn-lg btn-submit" value="submit" />
                           </div>

                       </div>
                   </div>
                   </form>
               </div>
           </section>

         </>
     )
     
};